module.exports = __webpack_public_path__ + "img/icon_location.7b91278d.svg";